import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import React from 'react';
import { SectionHeadline } from '@/components/SectionHeadline';
import { InfoBoxes } from '@/components/boxes';
import IconTruck from '@/assets/icons/heroIcons/Truck.svg';
import IconShieldCheck from '@/assets/icons/heroIcons/ShieldCheck.svg';
import IconCardFront from '@/assets/icons/heroIcons/Card-front.svg';
import IconReceiptRefund from '@/assets/icons/heroIcons/ReceiptRefund.svg';
export function WhySettleDebtsOnTime() {
  const $ = _c(45);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["shopWisely"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("whySettleDebtsOnTime.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline anchorKey="whySettleDebtsOnTime.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("whySettleDebtsOnTime.items.1.title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("whySettleDebtsOnTime.items.1.text");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconTruck />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4) {
    t6 = {
      title: t3,
      paragraph: t4,
      icon: t5
    };
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("whySettleDebtsOnTime.items.2.title");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("whySettleDebtsOnTime.items.2.text");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <IconShieldCheck />;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t8) {
    t10 = {
      title: t7,
      paragraph: t8,
      icon: t9
    };
    $[18] = t7;
    $[19] = t8;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("whySettleDebtsOnTime.items.3.title");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t) {
    t12 = t("whySettleDebtsOnTime.items.3.text");
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <IconCardFront />;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t11 || $[27] !== t12) {
    t14 = {
      title: t11,
      paragraph: t12,
      icon: t13
    };
    $[26] = t11;
    $[27] = t12;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t("whySettleDebtsOnTime.items.4.title");
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t) {
    t16 = t("whySettleDebtsOnTime.items.4.text");
    $[31] = t;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <IconReceiptRefund />;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t15 || $[35] !== t16) {
    t18 = {
      title: t15,
      paragraph: t16,
      icon: t17
    };
    $[34] = t15;
    $[35] = t16;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t10 || $[38] !== t14 || $[39] !== t18 || $[40] !== t6) {
    t19 = <InfoBoxes className="max-w-192!" items={[t6, t10, t14, t18]} variant="basic" />;
    $[37] = t10;
    $[38] = t14;
    $[39] = t18;
    $[40] = t6;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t19 || $[43] !== t2) {
    t20 = <div className="flex flex-col gap-10 px-4 lg:gap-16">{t2}{t19}</div>;
    $[42] = t19;
    $[43] = t2;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  return t20;
}